/* This file was generated automatically. Do not edit manually. */

export enum ExportScheduleFrequency {
    Hourly = 'Hourly',
    Daily = 'Daily',
    Weekly = 'Weekly',
    Monthly = 'Monthly',
    Quarterly = 'Quarterly',
    Yearly = 'Yearly',
}
